// AUTO-GENERATED by scripts/inline-icon-svg.mjs. Do not edit by hand.
// Source: assets/images/icon-hs-dark-nobg.svg
// Home-icon marker overlay used on StaticMapCard (replaces Google red pin). Transparent background so it floats on the map.
// Regenerate with: node scripts/inline-icon-svg.mjs

export const MAP_MARKER_SVG_XML = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0.00 0.00 1773.00 1773.00">
<path stroke="#857427" stroke-width="2.00" fill="none" stroke-linecap="butt" vector-effect="non-scaling-stroke" d="
  M 1267.95 679.22
  Q 1267.83 677.44 1267.83 675.00
  Q 1267.67 539.06 1267.64 537.31
  Q 1267.49 525.10 1267.32 521.50
  C 1266.98 514.11 1262.17 508.60 1255.09 506.84
  Q 1251.88 506.05 1246.34 506.03
  Q 1179.77 505.79 1135.01 506.04
  C 1127.30 506.08 1120.49 509.53 1117.61 516.75
  Q 1116.55 519.39 1116.41 525.53
  Q 1116.11 539.13 1115.69 553.16"
/>
<path fill="#dc9a18" d="
  M 1267.95 679.22
  Q 1267.83 677.44 1267.83 675.00
  Q 1267.67 539.06 1267.64 537.31
  Q 1267.49 525.10 1267.32 521.50
  C 1266.98 514.11 1262.17 508.60 1255.09 506.84
  Q 1251.88 506.05 1246.34 506.03
  Q 1179.77 505.79 1135.01 506.04
  C 1127.30 506.08 1120.49 509.53 1117.61 516.75
  Q 1116.55 519.39 1116.41 525.53
  Q 1116.11 539.13 1115.69 553.16
  Q 1107.77 548.66 1098.45 541.06
  Q 1083.63 528.98 1070.13 517.87
  C 1060.99 510.35 1051.34 503.30 1042.43 495.59
  Q 1036.01 490.04 1031.57 486.54
  C 1013.88 472.60 1000.19 461.05 982.81 447.36
  Q 974.15 440.54 960.43 429.06
  A 1.44 1.43 34.8 0 1 960.10 427.25
  Q 965.34 417.89 973.06 406.28
  C 1032.97 316.19 1144.41 273.05 1250.03 297.19
  Q 1304.09 309.55 1350.41 344.58
  Q 1361.46 352.93 1366.24 357.51
  C 1375.63 366.52 1385.33 375.76 1392.86 385.20
  Q 1410.94 407.88 1422.50 430.02
  Q 1428.15 440.83 1435.16 458.32
  C 1445.47 484.02 1450.65 510.69 1452.64 537.86
  C 1454.43 562.26 1452.05 586.57 1447.15 610.77
  Q 1444.61 623.32 1439.76 637.37
  Q 1422.64 686.97 1387.92 726.40
  Q 1375.48 740.53 1361.50 753.65
  A 1.25 1.25 0.0 0 1 1359.85 753.70
  L 1267.95 679.22
  Z"
/>
<path fill="#2d4e36" d="
  M 1115.69 553.16
  Q 1116.11 539.13 1116.41 525.53
  Q 1116.55 519.39 1117.61 516.75
  C 1120.49 509.53 1127.30 506.08 1135.01 506.04
  Q 1179.77 505.79 1246.34 506.03
  Q 1251.88 506.05 1255.09 506.84
  C 1262.17 508.60 1266.98 514.11 1267.32 521.50
  Q 1267.49 525.10 1267.64 537.31
  Q 1267.67 539.06 1267.83 675.00
  Q 1267.83 677.44 1267.95 679.22
  Q 1267.88 722.28 1267.93 764.75
  Q 1267.93 766.77 1270.14 768.54
  C 1299.97 792.36 1330.98 817.86 1373.58 852.90
  Q 1386.43 863.47 1393.20 868.79
  C 1402.01 875.71 1410.58 883.32 1419.24 890.22
  Q 1441.58 907.98 1494.92 951.60
  Q 1506.45 961.02 1500.38 974.60
  C 1498.78 978.20 1493.64 983.05 1490.58 987.18
  Q 1475.51 1007.45 1470.22 1013.72
  C 1462.27 1023.15 1452.17 1026.37 1441.69 1017.80
  Q 1248.79 860.01 1222.34 838.40
  Q 1111.54 747.87 1014.65 668.97
  Q 966.37 629.65 918.06 590.05
  Q 902.43 577.23 897.87 573.21
  C 895.73 571.32 891.02 568.31 887.77 567.99
  C 881.88 567.43 874.87 573.10 870.95 576.45
  C 858.52 587.07 842.68 599.52 832.85 607.69
  C 801.61 633.65 768.49 660.28 736.47 686.90
  C 722.57 698.46 708.33 709.45 694.31 721.18
  Q 674.19 738.01 647.16 759.52
  C 631.57 771.92 618.43 783.41 602.40 796.13
  Q 597.27 800.21 584.49 810.77
  Q 542.81 845.23 534.75 851.75
  Q 458.78 913.15 442.85 926.57
  Q 435.66 932.63 411.64 951.84
  C 397.12 963.47 385.30 974.04 370.31 985.87
  Q 353.35 999.27 333.98 1015.85
  C 332.19 1017.39 330.44 1018.41 327.84 1020.10
  C 319.58 1025.48 310.19 1022.69 304.40 1015.34
  Q 285.33 991.10 273.72 975.05
  C 269.70 969.48 270.31 961.69 274.15 956.05
  Q 275.64 953.85 280.11 950.19
  Q 288.96 942.93 347.69 894.93
  Q 434.89 823.66 593.96 694.12
  C 625.73 668.25 662.69 637.72 697.18 609.67
  Q 722.03 589.46 744.73 571.05
  C 787.23 536.57 827.92 502.53 871.61 467.34
  C 878.78 461.57 885.06 456.31 894.64 461.95
  Q 896.25 462.90 901.45 467.24
  Q 929.21 490.41 956.25 512.27
  Q 969.97 523.36 976.33 528.69
  C 986.23 537.00 994.48 543.04 1003.17 550.49
  C 1022.72 567.26 1047.96 586.84 1070.31 605.48
  Q 1087.92 620.16 1114.77 641.92
  A 0.55 0.55 0.0 0 0 1115.67 641.50
  L 1115.69 553.16
  Z"
/>
<path fill="#2d4e36" d="
  M 625.61 1478.82
  A 0.57 0.55 -87.1 0 1 625.06 1479.33
  Q 519.29 1479.21 437.00 1479.31
  C 434.84 1479.32 429.70 1479.38 427.03 1478.56
  Q 420.18 1476.46 416.53 1470.95
  C 412.56 1464.95 412.74 1459.32 412.74 1451.10
  Q 412.85 1217.28 412.56 1061.00
  Q 412.56 1060.39 412.95 1022.67
  C 413.07 1011.11 424.95 1002.60 432.96 996.20
  Q 452.09 980.89 507.93 934.94
  Q 514.14 929.83 522.76 922.74
  Q 538.59 909.72 549.56 900.89
  Q 566.06 887.60 576.40 879.08
  C 641.45 825.46 708.91 770.96 782.61 710.36
  Q 796.81 698.69 809.84 688.05
  Q 848.00 656.89 878.18 632.68
  Q 883.70 628.25 889.29 629.70
  Q 892.22 630.45 899.27 636.14
  C 920.51 653.26 940.68 670.09 957.28 683.58
  Q 1044.24 754.25 1143.58 835.76
  C 1155.61 845.63 1166.38 854.14 1181.25 866.32
  Q 1243.66 917.46 1345.82 1000.74
  C 1352.16 1005.91 1357.45 1010.12 1359.90 1017.51
  Q 1360.96 1020.69 1360.95 1028.91
  Q 1360.77 1283.19 1360.83 1448.90
  Q 1360.83 1457.78 1360.60 1460.08
  C 1359.82 1468.07 1354.90 1476.19 1347.23 1478.39
  Q 1344.11 1479.29 1337.50 1479.29
  Q 1058.05 1479.46 831.25 1479.25
  Q 825.99 1479.24 823.06 1479.16
  A 0.39 0.39 0.0 0 1 822.68 1478.77
  L 822.39 1131.64
  A 4.91 4.82 36.3 0 0 822.16 1130.23
  Q 818.98 1120.55 809.60 1116.46
  Q 807.61 1115.59 802.25 1115.58
  Q 659.93 1115.48 640.26 1115.72
  C 634.33 1115.79 628.53 1121.44 626.69 1127.06
  Q 625.88 1129.56 625.88 1136.51
  Q 625.91 1458.44 625.81 1475.50
  Q 625.81 1476.79 625.61 1478.82
  Z
  M 1163.02 1131.48
  A 15.93 15.93 0.0 0 0 1147.09 1115.55
  L 1013.85 1115.55
  A 15.93 15.93 0.0 0 0 997.92 1131.48
  L 997.92 1266.44
  A 15.93 15.93 0.0 0 0 1013.85 1282.37
  L 1147.09 1282.37
  A 15.93 15.93 0.0 0 0 1163.02 1266.44
  L 1163.02 1131.48
  Z"
/>
</svg>`;
